import { Button, Divider, Flex, Form, Modal, Select, Space } from "antd";
import { startTransition, useEffect, useRef, useState } from "react";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../../layouts/MainPagetitle";
import LeadCards from "./LeadCards";
import LeadsSearch from "./LeadsSearch/LeadsSearch";

const Leads = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
    order_by: "updatedAt",
    order_direction: "DESC",
    status: [
      "OPEN",
      "NOT_INTERESTED",
      "INTERESTED",
      "NOT_REACHABLE",
      "CALL_NOT_ANSWERED",
      "PENDING",
      "NOT_ELIGIBLE"
    ].join(","), // comma separated
  });

  // ---------------------------------------------------------------
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [editData, setEditData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [setsalesTeam, setSetsalesTeam] = useState([]);
  const initialColumnsRef = useRef([
    {
      dataIndex: "lead_name",
      title: "Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "loan_amount",
      title: "Loan Amt",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "location",
      title: "Location",
    },
    {
      dataIndex: "source",
      title: "Source",
      render: (text, record) => {
        return <>{text?.toTitleCase() || "-"}</>;
      },
    },
    {
      dataIndex: "status",
      title: "Lead Status",
      render: (text, record) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ]);
  const [rowcount, setRowcount] = useState(0);
  const [columns, setColumns] = useState(initialColumnsRef.current);
  const [cardData, setCardData] = useState({});
  const [roles, setRoles] = useState([]);
  const [isLeadAdded, setIsLeadAdded] = useState(false);

  const logColumns = [
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      render: (text) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      title: "Lead Status",
      dataIndex: "status",
      render: (text) => {
        return (
          <AppTag size="sm" color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
    { title: "Updated By", dataIndex: "updated_by_id" },
    { title: "Remarks", dataIndex: "remarks" },
  ];

  // useModalForm
  const modalConfigs = {
    leadsInfo: [
      {
        label: "Name",
        name: "lead_name",
        type: "text",
        placeholder: "Please Enter",
        required: true,
        disableOnEdit: true,
      },
      {
        label: "Mobile No.",
        name: "mobile_number",
        type: "text",
        placeholder: "Please Enter",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
        disableOnEdit: true,
      },
      {
        label: "Email ID",
        name: "email_address",
        type: "email",
        placeholder: "Please Enter",
        // rules: _enum.EMAIL_RULE,
        // required: true,
      },
      {
        label: "Source",
        name: "source",
        type: "select",
        options: [{ key: "SELF", label: "Self" }],
        placeholder: "Please Enter",
        required: true,
      },
      {
        label: "Req. Loan Amt.",
        name: "loan_amount",
        type: "number",
        placeholder: "Please Enter",
      },
      // {
      //   name: "location",
      //   label: "Work Location",
      //   type: "select",
      //   options: [],
      //   fetchKey: "location_name",
      //   fetchOptions: async () => {
      //     const data = await props.apis.apiGetMasterLocations();
      //     if (data) return data?.options("location_name");
      //     return [];
      //   },
      // },
      // {
      //   name: "state",
      //   label: "State",
      //   type: "text",
      //   // readOnly: true,
      // },
      {
        name: "city",
        label: "City",
        type: "text",
        // readOnly: true,
      },
      {
        label: "Lead Status",
        name: "status",
        type: "select",
        options: _enum.ADMIN_LEADS_STATUS,
        placeholder: "Please Enter",
        required: true,
      },
      {
        name: "product_type",
        label: "Product Type",
        type: "select",
        options: [],
        fetchOptions: () => props.apis.apiGetProductTypes(),
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "employee_type",
        label: "Employment Type",
        type: "select",
        options: _enum.LEAD_EMPLOYEE_TYPE,
        placeholder: "Please Enter",
        // required: true,
      },
      {
        label: "Remarks",
        name: "remarks",
        type: "textarea",
        colspan: 24,
      },
    ],
  };

  const dependencies = {
    location: async (value) => {
      if (value) {
        const res = await props.apis.apiGetLocationByName({
          location_name: value,
        });
        if (res) {
          return {
            valueUpdates: {
              // state: res?.state,
              city: res?.city,
            },
          };
        }
      }
      return {};
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  // ----------------- API helpers -----------------

  const getLeads = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "page",
        "limit",
        "order_by",
        "order_direction",
      ]);
      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    props.apis.apiGetLeads(payload).then(({ data, total }) => {
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
      setIsLeadAdded(false);
    });
  };

  const getRoles = async () => {
    const res = await props.apis.apiGetMasterStaticValues();
    if (res) {
      const rolesList = res?.roles?.filter(
        (v) => v !== "ADMINISTRATOR" && v !== "TELECALLER"
      );
      console.log({ rolesList });

      setRoles(rolesList.options ? rolesList.options() : rolesList);
    }
  };

  // ----------------- actions -----------------
  const view = async (record) => {
    const data = await props.apis.apiGetLeadsById({
      lead_id: record.lead_id,
    });
    setEditData(data);
    openModal("leadsInfo", "view", "View Lead", {
      ...data,
      city: data.location || "",
    });
  };

  const edit = async (record) => {
    const data = await props.apis.apiGetLeadsById({
      lead_id: record.lead_id,
    });
    setEditData(data);
    openModal("leadsInfo", "edit", "Edit Lead", {
      ...data,
      city: data.location || "",
    });
  };

  const deleteLead = (record) => {
    swal2
      .fire({
        title: "Are you sure you want to delete this lead?",
        icon: "info",
        iconColor: "#234C9B",
        showCancelButton: true,
        confirmButtonColor: "#234C9B",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis.apiDeleteLead({ lead_id: record.lead_id }).then((res) => {
            console.log({ apiDeleteLead: res });
            swal2.fire({
              title: "Lead Deleted",
              text: "Lead deleted successfully !!",
              icon: "success",
              iconColor: "#234C9B",
              timer: 4000,
            });
            getLeads();
          });
        }
      });
  };

  const handleAppModalSubmit = async (data) => {
    const payload = {
      ...Object.except(Object.removeEmpty(data), ["state", "city"]),
      location: data.city ? `${data.city}` : "",
    };

    if (modalState.mode === "edit") {
      await props.apis.apiUpdateLead(payload, {
        lead_id: editData.lead_id,
      });
      swal2.fire({
        title: "Lead updated successfully.",
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      closeModal();
      getLeads();
    } else if (modalState.mode === "add") {
      await props.apis.apiAddLead(payload);
      swal2.fire({
        title: "Lead added successfully.",
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      closeModal();
      setIsLeadAdded(true);
      getLeads();
    }
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getLeads(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getLeads(data, reset);
    }
  };

  const onPageChange = (pageData) => {
    console.log({ onPageChange: pageData });
    setSearch({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
    getLeads({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const downloadExcel = async () => {
    let payload = {};
    props.apis.apiExportLeads(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Leads_Details.xlsx`);
        link.click();
      }
    });
  };

  // ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [assignDept, setAssignDept] = useState(null);
  const [notSelected, setNotSelected] = useState(true);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => {
      let bool = true;
      if (record?.status === "INTERESTED") {
        bool = false;
      } else {
        bool = true;
      }
      return { disabled: bool };
    },
  };

  // ASSIGN DEPARTMENT

  const handleAssignDept = (val) => {
    setAssignDept(val);
  };

  const handleSubmitAssignDept = async () => {
    const payload = {
      leads: [...selectedRowKeys],
      assigned_role: assignDept || "",
    };
    if (assignDept === null) {
      swal2.fire({
        title: "Please select any department",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiAssignDeptToLead(payload);
      if (res) {
        swal2.fire({
          title: "Lead Assigned",
          text: "Lead assigned successfully !!",
          icon: "success",
          timer: 4000,
        });
        // clear select
        setSelectedRowKeys([]);
        getLeads();
      }
    }
  };

  // ----------------------------------------------------------------
  // ASSIGN TO
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignedToId, setAssignedToId] = useState(null);
  const [assigntoform] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    assigntoform.resetFields();
  };

  const openAssignedToModal = (record) => {
    console.log({ record });

    setAssignedToId([record?.lead_id]);
    getTelecallers();
    showModal();

    // if (record?.status === "INTERESTED") {
    //   setAssignedToId([record?.lead_id]);
    //   getTelecallers();
    //   showModal();
    // } else {
    //   swal2.fire({
    //     title: "Only INTERESTED leads can be assigned to Opps.",
    //     icon: "info",
    //     iconColor: "#008AD1",
    //     timer: 4000,
    //   });
    // }
  };

  const getTelecallers = async () => {
    const res = await props.apis.apiGetAllEmployees({
      role: _enum.ROUTE_PERSONAS.telecaller,
    });
    if (res) {
      const employeeLists = res?.data;
      console.log({ employeeLists });
      setEmployees(employeeLists.options("employee_id", "full_name"));
    }
  };

  const getSales = async () => {
    const res = await props.apis.apiGetAllEmployees({
      role: _enum.ROUTE_PERSONAS.ops,
    });
    if (res) {
      const salesLists = res?.data;
      setSetsalesTeam(salesLists.options("employee_id", "full_name"));
    }
  };

  const [assignSales, setAssignSales] = useState(null);

  const handleSalesAssign = async (value) => {
    console.log({ value });
    setAssignSales(value);
  };

  const handleSalesAssignSubmit = async () => {
    const payload = {
      assigned_person_id: assignSales || "",
    };
    console.log("Success:", payload);
    if (assignSales === null || assignSales === "") {
      swal2.fire({
        title: "Please select any sales team member",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiAssignSingleLead(payload, {
        lead_id: [...selectedRowKeys],
      });
      if (res) {
        swal2.fire({
          title: "Lead assigned to Sales Team Member successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        getLeads();
      }
    }
  };

  const handleAssignedTo = async (value) => {
    const payload = {
      assigned_person_id: value?.assignedTo || "",
    };
    console.log("Success:", value, payload);
    if (value?.assignedTo === null || value?.assignedTo === "") {
      swal2.fire({
        title: "Please select any telecallers",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiAssignSingleLead(payload, {
        lead_id: assignedToId,
      });
      if (res) {
        swal2.fire({
          title: "Lead assigned to Telecaller successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        assigntoform.resetFields();
        setIsModalOpen(false);
        getLeads();
      }
    }
  };

  // ----------------- lifecycle -----------------

  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      console.log("has values");
      setNotSelected(false);
    } else {
      console.log("has no values");
      setNotSelected(true);
    }
  }, [selectedRowKeys]);

  useEffect(() => {
    props.apis.apiGetDashboardMoke().then((res) => {
      setCardData(res);
    });

    getLeads();
    getRoles();
    getSales();
  }, []);

  // ---------------------------------------------------------------

  // HANDLE CHANGE PASSWORD MODAL

  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const handlePasswordSubmit = (values) => {
    let payload = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    };

    props.apis.apiPasswordReset(payload).then((res) => {
      console.log({ apiPasswordReset: res });
      if (res.status === 200) {
        swal2
          .fire({
            title:
              "Password changed successfully, Please re-login with new password",
            icon: "success",
            iconColor: "#234C9B",
          })
          .then((result) => {
            if (result.isConfirmed) {
              setPasswordModalOpen(false);
              props?.apis?.applogout();
            }
          });
      }
    });
  };

  useEffect(() => {
    const { isPasswordUpdated } = props?.$store?.user || {};
    if (!isPasswordUpdated) {
      setPasswordModalOpen(true);
    }
  }, []);
  props.$setNode({
    props,
    search,
    rowcount,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Leads"
        pageTitle={"Leads"}
        parentTitle={"Home"}
        pageIcon={imagepaths.SingleUserIconActive}
      />
      <div className="container-fluid">
        <LeadCards isLeadAdded={isLeadAdded} />
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <Flex
                  gap="middle"
                  align="center"
                  justify="end"
                  className="px-3"
                >
                  <Space size="small" split={<Divider type="vertical" />} wrap>
                    <AppButton
                      variant="excel"
                      onClick={(e) => downloadExcel(e)}
                    >
                      Download Excel
                    </AppButton>
                    <Select
                      allowClear
                      placeholder="Assign To"
                      options={roles?.map((v) => ({
                        value: v.key,
                        label: v.label,
                      }))}
                      onChange={(...args) => handleAssignDept(...args)}
                      style={{ width: 150 }}
                      disabled={notSelected}
                    />

                    <Select
                      allowClear
                      placeholder="Assign To Sales Team Member"
                      options={setsalesTeam?.map((v) => ({
                        value: v.key,
                        label: v.label,
                      }))}
                      onChange={(...args) => handleSalesAssign(...args)}
                      style={{ width: 250 }}
                      disabled={notSelected}
                    />

                    <LeadsSearch
                      onSearch={(...arg) => onSearch(...arg)}
                      handleAssignDept={handleAssignDept}
                      openModal={openModal}
                    />

                    <Button
                      type="primary"
                      className="btn btn-primary"
                      htmlType="button"
                      onClick={() =>
                        openModal("leadsInfo", "add", "Add Lead", {
                          source: "SELF",
                        })
                      }
                    >
                      + Add Lead
                    </Button>
                  </Space>
                </Flex>

                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  viewAction={(e) => view(e)}
                  editAction={(e) => edit(e)}
                  deleteAction={(e) => deleteLead(e)}
                  assignedToLink={true}
                  assignedToLinkAction={(e) => openAssignedToModal(e)}
                  checkbox={false}
                  rowSelection={rowSelection}
                  loading={isFetching}
                ></AppTable>

                <AppFormModal
                  form={appform}
                  title={modalState.title}
                  open={modalState.open}
                  onValuesChange={handleValuesChange}
                  onClose={closeModal}
                  fields={modalState.fields}
                  onSubmit={handleAppModalSubmit}
                  mode={modalState.mode}
                  extraSections={[
                    {
                      title: "Logs",
                      type: "table",
                      data: editData?.logs,
                      columns: logColumns,
                      showIn: [], // only show in view mode
                    },
                  ]}
                  persona={props?.$store?.user?.role}
                />
              </div>
            </div>
          </div>
        </div>

        {!notSelected && (
          <>
            <div className="row bottom_container pe-lg-5">
              <div className="col-12 text-end">
                <button
                  className="btn btn-primary m-3"
                  onClick={(e) => handleSubmitAssignDept(e)}
                >
                  Submit
                </button>

                <button
                  className="btn btn-primary m-3"
                  onClick={(e) => handleSalesAssignSubmit(e)}
                >
                  Submit Sales Team
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      <AppChangePasswordModal
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        onSubmit={handlePasswordSubmit}
      />

      {/* ASSIGN TO MODAL */}
      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: "none" } }}
        centered
        footer={null}
      >
        <Form
          form={assigntoform}
          layout="vertical"
          onFinish={handleAssignedTo}
          autoComplete="off"
        >
          <Form.Item
            label="Assign To"
            name="assignedTo"
            rules={[{ required: true, message: "Please select a value" }]}
          >
            <Select
              name="assignedTo"
              placeholder="Assign To"
              options={employees?.map((v) => ({
                value: v.key,
                label: v.label,
              }))}
              style={{ width: "100%" }}
              allowClear
              size="large"
              required={true}
            />
          </Form.Item>
          <Form.Item>
            <Button
              className="btn btn-primary"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default constore(Leads);
